import { render, staticRenderFns } from "./extract-line-details.vue?vue&type=template&id=87427cdc&scoped=true&"
import script from "./extract-line-details.vue?vue&type=script&lang=js&"
export * from "./extract-line-details.vue?vue&type=script&lang=js&"
import style0 from "./extract-line-details.vue?vue&type=style&index=0&id=87427cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87427cdc",
  null
  
)

export default component.exports